import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { PostCompanySubscriptionRequestEntity } from './PostCompanySubscriptionRequestEntity'
import type { PostCompanyOrderPeriodRequestEntity } from './PostCompanyOrderPeriodRequestEntity'
import type { MealTiersMiniEntity } from '@/features/mealTiers/domain/entities/MealTiersMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
export class CreateUpdateCompanyEntity {
  name?: string
  logo?: { bytes: string; fileName: string }
  location?: {
    longitude: number
    latitude: number
  }
  service?: ServiceMiniEntity
  mealTier?: MealTiersMiniEntity
  periods?: PostCompanyOrderPeriodRequestEntity[]
  subscription?: PostCompanySubscriptionRequestEntity
  timeBeforeMealLocksInMinute?: number
  startingMealTimeInMinute?: number
  maxItemPerUserPerMeal?: number
  branchs?: BranchMiniEntity[]
  applyToActiveNotLockedMeals?: boolean
  disabled?: boolean
}
